import React, { useState } from 'react';

import { Box, Flex } from '@chakra-ui/react';
import { openGifModalAction } from 'actions/gifModal';
import { EditorState } from 'draft-js';
import { useDispatch } from 'react-redux';
import MediaPreview from 'screens/home/addPost/MediaPreview';
import UploadTypesView from 'screens/home/addPost/UploadTypesView';
import { css } from 'styled-components';
import { commentPlaceholderStyles } from 'styles/common';

import { SEARCH_WIDGET_TYPES } from 'constants/ProjectConstants';

import { PostField } from 'uiToolkitV1/PostField/PostField';

import useUploadImage from '../hooks/useUploadImage';

const editorStyles = css`
  border: 0;
  min-height: 15vh;
  max-height: 25vh;
`;

type Props = {
  editorState: EditorState;
  onEnter: () => void;
  updateEditorState: (editorState: EditorState) => void;
  onEscape: () => void;
  placeholder: string;
  setImage?: (image: { url: string }) => void;
  onDeleteImage?: () => void;
  setGif?: (gif: string) => void;
  uploadedImage: {
    type: string;
    url: string;
  };
  uploadedGif: {
    type: string;
    url: string;
  };
  parentRef: any;
  useMentionFunctionality?: boolean;
  mentionExclusions?: string[];
  hideMediaMenu?: boolean;
};

const FeedbackRTE = ({
  editorState,
  onEnter,
  updateEditorState,
  onEscape,
  placeholder,
  setGif = () => {},
  setImage = () => {},
  onDeleteImage = () => {},
  uploadedImage,
  uploadedGif,
  parentRef,
  useMentionFunctionality = true,
  mentionExclusions = [],
  hideMediaMenu = false,
}: Props) => {
  const dispatch = useDispatch();

  const [emojiPlugin, setEmojiPlugin] = useState(null);

  const toggleGifModal = () => {
    dispatch(openGifModalAction({ onSelect: setGif }));
  };

  const { isUploading, uploadFile } = useUploadImage({ setImage });

  return (
    <Box>
      <Box style={{ position: 'relative', overflowY: 'auto' }}>
        <PostField
          placeholder={placeholder}
          height="10rem"
          updateEditorState={updateEditorState}
          editorState={editorState}
          editorStyles={editorStyles}
          placeholderStyles={commentPlaceholderStyles}
          onEnter={onEnter}
          widgetType={SEARCH_WIDGET_TYPES.post}
          onEscape={onEscape}
          useEmojiFunctionality
          useHashtagFunctionality
          useMentionFunctionality={useMentionFunctionality}
          // @ts-ignore
          setEmojiPlugin={setEmojiPlugin}
          portalParentRef={parentRef}
          usePortalForSuggestions
          mentionExclusions={mentionExclusions}
          allowNewLine
          allowEnterToNextLine
        />
        <MediaPreview
          fileUrl={uploadedImage?.url ?? ''}
          deleteFile={onDeleteImage}
          uploading={isUploading}
          uploadFile={uploadFile}
          setGif={setGif}
          gifUrl={uploadedGif?.url ?? ''}
          className="media-preview-feedback"
        />
      </Box>
      {!hideMediaMenu && (
        <Flex
          position="relative"
          sx={{
            '.emojiSelectPopover-postfield': {
              bottom: 'initial !important',
            },
          }}
        >
          <UploadTypesView
            uploadFile={uploadFile}
            toggleGifModal={toggleGifModal}
            gifUrl={uploadedGif?.url ?? ''}
            uploadedImage={uploadedImage?.url ?? ''}
            EmojiSelect={emojiPlugin?.EmojiSelect}
            iconSize="header"
            className="upload-types-view-feedback"
          />
        </Flex>
      )}
    </Box>
  );
};

export default FeedbackRTE;
